module.exports = __webpack_public_path__ + "static/media/mongolia-small.74fc24d9.jpg";